import thunk from 'redux-thunk';
import * as types from './actionTypes';
import { handleError } from '../errors/handleError';
import {
    getCloverToken,
    getCloverProductsViaAPI,
    getCloverPayloadFromProductViaAPI,
} from '../apis/CloverApi';
import { getObjectKeyFromValue } from '../objects/getObjectKeyFromValue';
import {
    updateProjectVersionWithMedia,
    updateProjectVersionForSermonDisconnect,
} from './projectVersionsActions';
import constants from '../constants';
import i18n from '../i18n';
import { addAlert } from './alertActions';

export function errorHandler(dispatch, error, type) {
    let errorMessage = '';
    if (error.status === 401) {
        dispatch(addAlert({
            message: i18n.t('clover.invalid-login'),
            view: '/modules/sermons',
            type: 'error',
            id: 'invalid-login',
            dismissable: true,
        }));
    } else {
        errorMessage = handleError(error);
    }
    dispatch({
        type,
        error: errorMessage,
    });

    const clearError = () => {
        dispatch({
            type,
            error: '',
        });
    };

    setTimeout(clearError, 3000);
}

export function setSelectedCloverPage(pageId, payload, product, projectVersionIn) {
    let projectVersion = projectVersionIn;
    const mediaItems = payload.media_item_uuid;
    const mediaItemUUId = getObjectKeyFromValue(mediaItems, pageId);
    if (!mediaItemUUId) {
        return {
            type: types.GET_CLOVER_PAGES_FAILURE,
            error: i18n.t('clover.not-found'),
        };
    }
    if (typeof projectVersion === 'string') {
        projectVersion = {};
    }
    projectVersion.cloverAccountEmail = product.owner.email;
    projectVersion.cloverAccountProduct = product.product_name;
    projectVersion.mediaUrl = `http://${projectVersion.cloverAccountProduct}.cloversites.com/podcast/${mediaItemUUId}.xml`;
    projectVersion.mediaType = constants.MediaType.find((n) => { return n.Name === 'Clover'; }).Id;
    return function (dispatch) {
        dispatch({
            type: types.CLEAR_CLOVER_OBJECTS,
        });
        return dispatch(updateProjectVersionWithMedia(projectVersion.projectId, projectVersion));
    };
}

export function getCloverProductPages(product, cloverToken, projectVersion) {
    return function (dispatch) {
        dispatch({
            type: types.GET_CLOVER_PAGES,
        });
        const handleResponseFn = function (response) {
            const payload = response.data;
            const mediaItems = payload.media_item_uuid;

            const filterToMediaPages = (page) => {
                const mediaSection = getObjectKeyFromValue(mediaItems, page.id);
                return mediaSection && mediaSection.length > 0;
            };

            const pages = payload.pages.filter(filterToMediaPages);
            if (pages.length === 0) {
                dispatch(addAlert({
                    message: i18n.t('clover.not-found'),
                    view: '/modules/sermons',
                    type: 'error',
                    id: 'invalid-pages',
                    dismissable: true,
                }));
                dispatch({
                    type: types.CLEAR_CLOVER_OBJECTS,
                });
            }
            if (pages.length === 1) {
                dispatch(setSelectedCloverPage(pages[0].id, payload, product, projectVersion));
            } else {
                dispatch({
                    type: types.GET_CLOVER_PAGES_SUCCEED,
                    pages,
                    payload,
                    token: cloverToken,
                    select: product,
                });
            }
        };

        const handleErrorFn = (error) => {
            errorHandler(dispatch, error, types.GET_CLOVER_PRODUCTS_FAILED);
        };

        return getCloverPayloadFromProductViaAPI(product.product_name, cloverToken)
            .then(handleResponseFn)
            .catch(handleErrorFn);
    };
}

export function getCloverProducts(username, password, projectVersion) {
    return function (dispatch) {
        let apiToken = '';

        dispatch({
            type: types.GET_CLOVER_PRODUCTS_PENDING,
        });

        const handleTokenResponse = (tokenResponse) => {
            return new Promise((resolve, reject) => {
                try {
                    apiToken = tokenResponse.data.data.access_token;
                    resolve(tokenResponse);
                } catch {
                    reject(tokenResponse);
                }
            });
        };

        const handleResponse = (productResponse) => {
            if (productResponse.data.length > 1) {
                dispatch({
                    type: types.GET_CLOVER_PRODUCTS_SUCCESS,
                    payload: productResponse.data,
                    token: apiToken,
                });
            } else {
                dispatch({
                    type: types.GET_CLOVER_PRODUCTS_SUCCESS,
                });
                dispatch(getCloverProductPages(productResponse.data[0], apiToken, projectVersion));
            }
        };

        const handleErrorFn = (error) => {
            errorHandler(dispatch, error.response, types.GET_CLOVER_PRODUCTS_FAILED);
        };
        return getCloverToken(username, password)
            .then(handleTokenResponse)
            .then(getCloverProductsViaAPI)
            .then(handleResponse)
            .catch(handleErrorFn);
    };
}

export function disconnectCloverAccount(projectVersionIn) {
    return function (dispatch) {
        let projectVersion = projectVersionIn;
        dispatch({
            type: types.CLEAR_CLOVER_OBJECTS,
        });
        projectVersion.cloverAccountEmail = '';
        projectVersion.cloverAccountProduct = '';
        projectVersion.mediaUrl = null;
        projectVersion.mediaType = 0;

        dispatch(updateProjectVersionForSermonDisconnect(projectVersion.projectId, projectVersion));
    };
}
